module.exports = __webpack_public_path__ + "static/img/130003.25a6fa29.png";